export const translations = {
  en: {
    welcome: "Constructing the Future.",
    heroSubtitle: "Quality. Precision. Trust.",
    services: "Services",
    ourActivity: "Our Activity",
    ourValues: "Our Values",
    partners: " Our Partners",

    // Services

    service1_title: "Excavation Works",
    service1_description:
      "We provide expert excavation services, from site clearing to trench digging, ensuring your project starts on solid ground.",
    service2_title: "Carpentry Works",
    service2_description:
      "Our carpenters craft high-quality woodwork, including framing, roofing, and custom cabinetry, to meet your specific needs.",
    service3_title: "Iron Works",
    service3_description:
      "We specialize in durable and precise ironwork, including gates, railings, and structural supports.",
    service4_title: "Concrete Works",
    service4_description:
      "Offering a range of concrete services, from foundations to decorative finishes, for residential and commercial buildings.",
    service5_title: "Roofing Works",
    service5_description:
      "Our roofing experts ensure reliable, long-lasting roofs, handling installations, repairs, and replacements.",
    service6_title: "Brick Wall Works",
    service6_description:
      "We build and repair brick walls with precision, adding both structural integrity and aesthetic value to your property.",
    service7_title: "Plastering Works",
    service7_description:
      "Our plastering services provide smooth, durable finishes for both interior and exterior surfaces, enhancing your space.",
    service8_title: "Facade Works",
    service8_description:
      "Transform the look of your building with our expert facade services, including restoration, installation, and cladding.",
    service9_title: "Canopy System Works",
    service9_description:
      "We design and install functional canopy systems, providing shelter and aesthetic appeal for your property.",
    service10_title: "Ventilated Facade Works",
    service10_description:
      "Our ventilated facades improve energy efficiency and airflow while adding a modern touch to your building’s exterior.",
    service11_title: "Tiling Works",
    service11_description:
      "Our tiling services cover everything from floors to walls, offering a variety of styles and high-quality installations.",
    service12_title: "Decorative Coating Works",
    service12_description:
      "We specialize in decorative coatings that enhance the look and feel of your space, combining beauty with protection.",
    service13_title: "Renovation Works",
    service13_description:
      "Our renovation services transform existing spaces, upgrading interiors and exteriors to meet modern standards.",
    service14_title: "Plumbing Works",
    service14_description:
      "From installations to repairs, our plumbing services cover everything from pipes to fixtures, ensuring a well-functioning system.",
    service15_title: "Insulation Works",
    service15_description:
      "We provide insulation solutions to improve energy efficiency, reduce noise, and create comfortable indoor environments.",
    service16_title: "Electrical Works",
    service16_description:
      "Our licensed electricians offer reliable electrical installations, repairs, and maintenance for both residential and commercial properties.",

    // Values

    value1_title: "Excellence and Quality",
    value1_description:
      "We make the best efforts with endless passion and a challenging spirit to meet and exceed every expectation, to become the best in every way.",
    value2_title: "Integrity & Security",
    value2_description:
      "We fulfill our mission’s promise through behavior that reflects honesty, responsibility, & justice in action.",
    value3_title: "Teamwork & Collaboration",
    value3_description:
      "We work together towards a common goal, making what we do better and improving every day.",

    //Home

    home: "Home",
    mainHome: "Main Home",
    features: "Services",
    dashboard: "Dashboard",
    projects: "Projects",
    allProjects: "All Projects",
    ProBuild: "ProBuild",
    materials: "Materials",
    about: "About",
    jobs: "Jobs",
    reviews: "Reviews",
    contact: "Contact",
    signIn: "Sign in",

    //Footer

    contacts: "Contacts",
    address:
      "Kajo Karafili Street, BimBashi Building, Floor 4, Tirana, Albania",
    phone: "+355 69 20 73 347",
    email: "Email",
    location: "Location",
    locationText: "Floor 4, Tirana, Albania",
    rightsReserved: 'All Rights Reserved by "H&O"',

    //Contact

    contactUs: "Contact Us",
    contactDirect: "Contact us directly at:",
    name: "Name",
    message: "Message",
    sendMessage: "Send Message",
    formSuccess: "Thank you! We will get back to you shortly.",
    formError: "Oops! There was an issue sending the form.",
    contactImageAlt: "Contact Us Image",

    //About

    companyName: "H&O Company",
    aboutTitle: "About H&O",
    aboutIntro:
      "H&O is a construction company with an extensive and excellent reputation, built on the values of excellence and integrity, tested over the years.",
    aboutProjects:
      "Over the years, H&O has completed numerous projects in the field of civil and industrial construction, such as residential buildings, industrial and infrastructure construction, social and cultural centers, in collaboration with various prestigious companies in Albania.",
    aboutStartTitle: "How It Started!",
    aboutStartDescription:
      "Founded in 2002 as an individual business focused on the construction and reconstruction of residential buildings and the trade of building materials, H&O has rapidly grown into an ambitious company that offers quality work while being innovative, reliable, and committed to excellence.",
    totalProjects: "Total Projects",
    completed: "Completed",
    inProgress: "In Progress",
    safetyHealth: "Safety and Health",
    safetyHealthPara1:
      "At H&O, we prioritize the safety and health of our employees, clients, and partners. Our commitment to safety is unwavering, ensuring that all projects meet the highest safety standards and practices. We believe that a safe environment is essential for productivity and success, and we continuously invest in training and equipment to protect our teams and our community.",
    safetyHealthPara2:
      "Through rigorous protocols and constant vigilance, we aim to maintain a workspace that fosters well-being and security. Every project adheres to strict health guidelines to safeguard everyone involved, making H&O a leader in responsible and ethical practices.",
    safetyExample1: "Safety precaution example 1",
    safetyExample2: "Safety precaution example 2",
    safetyExample3: "Safety precaution example 3",
    safetyExample4: "Safety precaution example 4",
    shareExperience: "Share your experience",

    //Reviews

    User: "User",
    logout: "Logout",
    loginFailed: "Login Failed",
    feedbackDesc:
      "Tell us what you think — your feedback makes a real difference.",
    leaveComment: "Leave a comment...",
    submitRating: "Submit Rating",
    alreadyRated: "You have already rated us. Thank you!",
    topReviews: "Top Reviews",
    basedOnReviews: "Based on {{count}} reviews",
    whatCustomersSay: "What our customers say",

    //Pojects

    ourProjects: "OUR PROJECTS",
    seeMore: "See More",
    tiranaCieloTitle: "TIRANA CIELO",
    tiranaCieloDesc: "Residential Complex in Mjull Bathore near TEG.",
    samiFrasheriTitle: "SAMI FRASHERI",
    samiFrasheriDesc: "Renovation near the center of Tirana.",
    lakeViewTitle: "LAKE VIEW",
    lakeViewDesc: "High-standard building in Tirana.",
    deltaResidenceTitle: "DELTA RESIDENCE",
    deltaResidenceDesc: "High-standard building in Tirana.",
    katedraljaTitle: "KATEDRALJA RINGJALLJA E KRISHTIT",
    katedraljaDesc: "New Orthodox Church in the center of Tirana.",
    hotelLuaniTitle: "HOTEL LUANI ARTE",
    hotelLuaniDesc:
      "The 5-story hotel was built in the city of Shkodra with high standards...",
    spaWellnessTitle: "“LUANI A” SPA & WELLNESS CENTER",
    spaWellnessDesc:
      "The building is located in the city of Shkodra, with high standards...",
    aeroportiTitle: "AEROPORTI NENE TEREZA",
    aeroportiDesc:
      'The international airport "Nënë Tereza" is the airport of ...',

    // General

    backToAllJobs: "← Back to All Jobs",
    searchPlaceholder: "Search",
    OpenPositions: "Open Positions",
    applyNow: "Apply Now",
    yourApplications: "Your Applications",
    jobTitle: "Job Title",
    appliedOn: "Applied on",
    status: "Status",
    pending: "Pending",
    closed: "Closed",
    noApplicationsYet: "You have not applied to any jobs yet",
    responsibilities: "Responsibilities",
    requirements: "Requirements",
    deadline: "Deadline",
    jobDetailsNotFound: "Job details not found",
    fillAllFields: "Please fill all fields and upload your resume.",
    Submit: "Submit",
    formSubmitted: "Application Submitted Successfully",

    // Construction Engineer

    constructionEngineerTitle: "Construction Engineer",
    constructionEngineerDescription:
      "As a Construction Engineer, you will oversee project design and implementation, ensuring compliance with safety and quality standards.",
    responsibilityConstructionEngineer1:
      "Plan, design, and supervise construction projects from start to finish.",
    responsibilityConstructionEngineer2:
      "Prepare cost estimates, budgets, and schedules.",
    responsibilityConstructionEngineer3:
      "Collaborate with architects, contractors, and stakeholders.",
    responsibilityConstructionEngineer4:
      "Ensure compliance with building codes and safety regulations.",
    requirementConstructionEngineer1:
      "Bachelor’s degree in Civil or Construction Engineering.",
    requirementConstructionEngineer2:
      "Minimum 3 years of experience in construction project management.",
    requirementConstructionEngineer3:
      "Excellent problem-solving and communication skills.",
    requirementConstructionEngineer4:
      "Proficiency in AutoCAD, Revit, or similar design software.",

    // Construction Worker

    constructionWorkerTitle: "Construction Worker",
    constructionWorkerDescription:
      "We are seeking motivated Construction Workers to join our team in executing high-quality construction projects.",
    responsibilityConstructionWorker1:
      "Assist in concrete mixing, site preparation, and material handling.",
    responsibilityConstructionWorker2:
      "Follow blueprints and project instructions accurately.",
    responsibilityConstructionWorker3: "Operate hand and power tools safely.",
    responsibilityConstructionWorker4:
      "Ensure compliance with safety and health guidelines on site.",
    requirementConstructionWorker1:
      "Previous experience in construction or related work preferred.",
    requirementConstructionWorker2:
      "Ability to perform physical labor and work outdoors.",
    requirementConstructionWorker3: "Strong teamwork and reliability.",
    requirementConstructionWorker4:
      "Basic understanding of construction procedures and tools.",

    // Construction Foreman

    constructionForemanTitle: "Construction Foreman",
    constructionForemanDescription:
      "The Construction Foreman will lead and coordinate teams of workers, ensuring that all operations are completed safely, efficiently, and on schedule.",
    responsibilityConstructionForeman1:
      "Supervise construction workers and subcontractors on site.",
    responsibilityConstructionForeman2:
      "Monitor project progress and report to the project manager.",
    responsibilityConstructionForeman3:
      "Ensure that safety and quality standards are met.",
    responsibilityConstructionForeman4:
      "Coordinate daily activities and resolve on-site issues promptly.",
    requirementConstructionForeman1:
      "Proven experience as a Foreman or similar supervisory role.",
    requirementConstructionForeman2:
      "Strong leadership and communication skills.",
    requirementConstructionForeman3:
      "Excellent knowledge of construction processes and safety practices.",
    requirementConstructionForeman4:
      "Ability to read blueprints and technical drawings.",

    // Construction Archaeologist

    constructionArchaeologistTitle: "Construction Archaeologist",
    constructionArchaeologistDescription:
      "As a Construction Archaeologist, you will assess and monitor construction projects to identify and preserve archaeological findings.",
    responsibilityConstructionArchaeologist1:
      "Conduct archaeological assessments before and during construction.",
    responsibilityConstructionArchaeologist2:
      "Document findings and prepare detailed reports.",
    responsibilityConstructionArchaeologist3:
      "Collaborate with site managers to minimize site impact.",
    responsibilityConstructionArchaeologist4:
      "Ensure legal compliance with heritage conservation standards.",
    requirementConstructionArchaeologist1:
      "Degree in Archaeology, Anthropology, or related field.",
    requirementConstructionArchaeologist2:
      "Strong research and documentation skills.",
    requirementConstructionArchaeologist3:
      "Ability to work collaboratively on active construction sites.",
    requirementConstructionArchaeologist4:
      "Attention to detail and respect for cultural heritage.",

    // Architectural Designer

    architecturalDesignerTitle: "Architectural Designer",
    architecturalDesignerDescription:
      "We are looking for a creative Architectural Designer to produce innovative designs for residential and commercial projects. ",
    responsibilityArchitecturalDesigner1:
      "Develop design concepts and 3D visualizations.",
    responsibilityArchitecturalDesigner2:
      "Collaborate with engineering teams and project managers.",
    responsibilityArchitecturalDesigner3:
      "Prepare technical drawings and specifications.",
    responsibilityArchitecturalDesigner4:
      "Ensure designs comply with local regulations and sustainability goals.",
    requirementArchitecturalDesigner1:
      "Bachelor’s degree in Architecture or related field.",
    requirementArchitecturalDesigner2:
      "Proficiency in AutoCAD, SketchUp, or Revit.",
    requirementArchitecturalDesigner3:
      "Strong design portfolio showcasing creativity and technical ability.",
    requirementArchitecturalDesigner4:
      "Excellent communication and teamwork skills.",

    // Project Coordinator

    projectCoordinatorTitle: "Project Coordinator",
    projectCoordinatorDescription:
      "As a Project Coordinator, you will assist in planning, executing, and finalizing projects within budget and deadlines. ",
    responsibilityProjectCoordinator1:
      "Assist in scheduling, budgeting, and reporting.",
    responsibilityProjectCoordinator2:
      "Communicate project progress with stakeholders.",
    responsibilityProjectCoordinator3:
      "Maintain project documentation and contracts.",
    responsibilityProjectCoordinator4:
      "Support the project manager in day-to-day activities.",
    requirementProjectCoordinator1:
      "Bachelor’s degree in Management, Engineering, or similar field.",
    requirementProjectCoordinator2:
      "Strong organizational and multitasking skills.",
    requirementProjectCoordinator3:
      "Excellent verbal and written communication abilities.",
    requirementProjectCoordinator4:
      "Knowledge of project management software is a plus.",

    // Structural Engineer

    structuralEngineerTitle: "Structural Engineer",
    structuralEngineerDescription:
      "The Structural Engineer will design, plan, and oversee the construction of load-bearing structures. ",
    responsibilityStructuralEngineer1:
      "Develop structural designs and calculations.",
    responsibilityStructuralEngineer2:
      "Review architectural drawings for structural integrity.",
    responsibilityStructuralEngineer3:
      "Collaborate with construction and design teams.",
    responsibilityStructuralEngineer4:
      "Conduct site inspections and issue compliance reports.",
    requirementStructuralEngineer1:
      "Degree in Structural or Civil Engineering.",
    requirementStructuralEngineer2:
      "Strong knowledge of Eurocodes and design standards.",
    requirementStructuralEngineer3:
      "Experience with structural analysis software.",
    requirementStructuralEngineer4:
      "Attention to detail and problem-solving mindset.",

    // Installation Foreman

    installationForemanTitle: "Installation Foreman",
    installationForemanDescription:
      "We are seeking an experienced Installation Foreman to supervise the installation of mechanical, electrical, and plumbing systems.",
    responsibilityInstallationForeman1:
      "Plan and oversee installation activities on site.",
    responsibilityInstallationForeman2:
      "Supervise technicians and subcontractors.",
    responsibilityInstallationForeman3:
      "Ensure quality and compliance with technical standards.",
    responsibilityInstallationForeman4:
      "Monitor progress and report any deviations to management.",
    requirementInstallationForeman1:
      "Technical degree in Engineering or related field.",
    requirementInstallationForeman2:
      "Minimum 3 years of experience as Installation Foreman.",
    requirementInstallationForeman3:
      "Strong leadership and organizational skills.",
    requirementInstallationForeman4:
      "Knowledge of MEP systems and technical drawings.",

    //BuildCostpro

    objectType: "Object Type",
    area: "Area (m²)",
    enterArea: "Enter total area",
    quality: "Quality",
    pricePerM2: "Price / m² (€)",
    workerPerM2: "Worker / m² (€)",
    transportPerM2: "Transport / m² (€)",
    discount: "Discount (%)",
    tax: "Tax (%)",
    totalCost: "Total Estimated Cost",
    buyProject: "Buy Project",
    introTitle: "Plan smarter, build better.",
    introText:
      "Estimate your construction costs in seconds – transparent, easy, and reliable.",
    howItWorks: "How It Works",
    step1: "Step 1: Choose the object type.",
    step2: "Step 2: Enter the area.",
    step3: "Step 3: Select the quality and review auto-filled costs.",
    step4: "Step 4: Calculate the total cost.",
    factTitle: " Professional Estimation?",
    factText:
      "Generate transparent and reliable construction cost estimates to support better planning and decision-making.",
    errorMessage: "You have to login!",

    // Features

    planningDesignTitle: "Planning & Design",
    planningDesignDesc:
      "We provide detailed planning and professional design services for every construction project.",

    engineeringTeamTitle: "Engineering Team",
    engineeringTeamDesc:
      "Our experienced engineers and specialists ensure reliable and efficient project execution.",

    constructionSiteTitle: "Construction Site",
    constructionSiteDesc:
      "We manage every construction phase with high-quality standards and on-time delivery.",

    premiumMaterialsTitle: "Premium Materials",
    premiumMaterialsDesc:
      "We use certified, high-quality materials to ensure durable and long-lasting results.",

    completedProjectsTitle: "Completed Projects",
    completedProjectsDesc:
      "Our completed projects demonstrate our expertise, quality, and commitment to excellence.",
    featuresHeaderTitle: "Our Construction Features",
    featuresHeaderDesc:
      "Discover the key strengths that make our construction services reliable, efficient, and high quality.",

    //Cookis

    cookieTitle: "We use cookies",
    cookieBannerMessage:
      "We use cookies to improve your experience. Please choose your preferences:",
    essentialCookies: "Essential Cookies",
    analyticsCookies: "Analytics Cookies",
    marketingCookies: "Marketing Cookies",
    savePreferences: "Save",
    acceptAll: "Accept all",

    //Aplication

    applyingFor: "Applying for",
    resume: "Resume",
    somethingWrong: "Something went wrong.",
    serverError: "An error occurred. Please try again later.",
    invalidEmail: "Please enter a valid email address.",
    seeApplications: "See Applications",
    //Materials

    exploreMaterials: "Explore Materials",
    materialsIntro: "Here you can find information about our materials...",
    Wood: "Wood",
    "Premium quality wood for construction and design, offering durability and aesthetic appeal.":
      "Premium quality wood for construction and design, offering durability and aesthetic appeal.",

    Concrete: "Concrete",
    "High-grade concrete for strong foundations and sustainable structures.":
      "High-grade concrete for strong foundations and sustainable structures.",

    Steel: "Steel",
    "Robust and corrosion-resistant steel for architectural and industrial applications.":
      "Robust and corrosion-resistant steel for architectural and industrial applications.",

    Glass: "Glass",
    "Crystal-clear glass for modern and sleek designs, ensuring durability and style.":
      "Crystal-clear glass for modern and sleek designs, ensuring durability and style.",

    Tiles: "Tiles",
    "Elegant tiles with diverse patterns, perfect for interior and exterior spaces.":
      "Elegant tiles with diverse patterns, perfect for interior and exterior spaces.",

    Granite: "Granite",
    "Durable and elegant granite for countertops, flooring, and other construction needs.":
      "Durable and elegant granite for countertops, flooring, and other construction needs.",

    Brick: "Brick",
    "Reliable and affordable bricks for traditional and modern building projects.":
      "Reliable and affordable bricks for traditional and modern building projects.",

    Marble: "Marble",
    "Luxurious marble for sophisticated interiors and exteriors.":
      "Luxurious marble for sophisticated interiors and exteriors.",

    Aluminum: "Aluminum",
    "Lightweight and versatile aluminum for construction and design.":
      "Lightweight and versatile aluminum for construction and design.",

    PVC: "PVC",
    "Cost-effective and durable PVC for pipes, windows, and more.":
      "Cost-effective and durable PVC for pipes, windows, and more.",

    Sand: "Sand",
    "Clean and fine sand ideal for masonry and plastering.":
      "Clean and fine sand ideal for masonry and plastering.",

    Cement: "Cement",
    "High-quality cement for strong and durable structures.":
      "High-quality cement for strong and durable structures.",

    Plasterboard: "Plasterboard",
    "Efficient and easy-to-install plasterboard for walls and ceilings.":
      "Efficient and easy-to-install plasterboard for walls and ceilings.",

    Asphalt: "Asphalt",
    "Reliable asphalt for durable and smooth roads and pavements.":
      "Reliable asphalt for durable and smooth roads and pavements.",

    "Insulation Materials": "Insulation Materials",
    "Thermal and acoustic insulation for energy-efficient buildings.":
      "Thermal and acoustic insulation for energy-efficient buildings.",

    "Roofing Materials": "Roofing Materials",
    "Durable and weather-resistant roofing materials for all building types.":
      "Durable and weather-resistant roofing materials for all building types.",

    "Adhesives & Sealants": "Adhesives & Sealants",
    "High-quality adhesives and sealants for secure bonding and sealing.":
      "High-quality adhesives and sealants for secure bonding and sealing.",

    Ceramics: "Ceramics",
    "Aesthetic and durable ceramics for interior and exterior applications.":
      "Aesthetic and durable ceramics for interior and exterior applications.",

    Gypsum: "Gypsum",
    "Versatile gypsum for walls, ceilings, and decorative applications.":
      "Versatile gypsum for walls, ceilings, and decorative applications.",

    "Paints & Coatings": "Paints & Coatings",
    "Wide range of paints and coatings for protective and decorative finishes.":
      "Wide range of paints and coatings for protective and decorative finishes.",

    "Pipes & Plumbing Materials": "Pipes & Plumbing Materials",
    "Durable pipes and fittings for water supply and drainage systems.":
      "Durable pipes and fittings for water supply and drainage systems.",

    "Electrical Materials": "Electrical Materials",
    "Cables, switches, and other electrical materials for residential and industrial use.":
      "Cables, switches, and other electrical materials for residential and industrial use.",

    Timber: "Timber",
    "Natural and engineered timber for construction and furniture.":
      "Natural and engineered timber for construction and furniture.",

    Stone: "Stone",
    "Natural stone for landscaping, paving, and structural use.":
      "Natural stone for landscaping, paving, and structural use.",

    "Metal Sheets": "Metal Sheets",
    "High-quality metal sheets for roofing and industrial applications.":
      "High-quality metal sheets for roofing and industrial applications.",

    "Composite Materials": "Composite Materials",
    "Innovative composite materials for strength and lightweight construction.":
      "Innovative composite materials for strength and lightweight construction.",

    "Fiber Cement Boards": "Fiber Cement Boards",
    "Durable and fire-resistant fiber cement boards for walls and cladding.":
      "Durable and fire-resistant fiber cement boards for walls and cladding.",

    //Notifications

    notifications: "Notifications",
    noNotifications: "No notifications",

    //Help

    welcomeMessage:
      "Welcome! For account access, please use the main header login.",
    categories: "Categories",
    helpCenter: "Help Center",
    noResults: "Sorry, we could not find any matching questions.",
    needAssistance: "Need more assistance?",
    contactMessage:
      "Contact our support team and we’ll get back to you as soon as possible.",
    "Projects & Services": "Projects & Services",
    "Payments & Billing": "Payments & Billing",
    "Account Settings": "Account Settings",
    "Technical Issues": "Technical Issues",
    faq_project_1_q: "How do I start a construction project?",
    faq_project_1_a:
      'Fill out the project form under "Services", and our team will contact you.',

    faq_project_2_q: "How can I track my project progress?",
    faq_project_2_a:
      "Once registered, you can track your project progress in your profile.",

    faq_project_3_q: "Can I request multiple projects at once?",
    faq_project_3_a:
      "Yes, you can submit multiple project requests, and our team will manage them efficiently.",

    faq_project_4_q: "Do you provide consultation before starting?",
    faq_project_4_a:
      "Absolutely, we offer free consultation to discuss your requirements.",

    faq_project_5_q: "How long does a typical project take?",
    faq_project_5_a:
      "Project timelines depend on the scope, but we provide estimated durations for each project.",

    faq_project_6_q: "Can I customize the design?",
    faq_project_6_a:
      "Yes, our team will work with you to customize your project design.",

    // Payments & Contracts

    faq_payment_1_q: "What payment methods do you accept?",
    faq_payment_1_a: "We accept bank transfer, credit card, and cash payments.",

    faq_payment_2_q: "Are official contracts provided?",
    faq_payment_2_a:
      "Yes, every project comes with an official contract for transparency and security.",

    faq_payment_3_q: "Can I get a refund if needed?",
    faq_payment_3_a:
      "Refunds are processed according to the contract terms agreed upon before starting the project.",

    faq_payment_4_q: "Do you offer installment payments?",
    faq_payment_4_a:
      "Yes, payment installments are available for eligible projects.",

    faq_payment_5_q: "Are invoices provided?",
    faq_payment_5_a:
      "Yes, detailed invoices are issued for every payment made.",

    // Contact & Support

    faq_support_1_q: "How can I contact the company?",
    faq_support_1_a: "You can contact us via the contact form or by phone.",

    faq_support_2_q: "What are your working hours?",
    faq_support_2_a: "Monday to Friday, 8:00 AM - 5:00 PM.",

    faq_support_3_q: "Do you offer online support?",
    faq_support_3_a: "Yes, our support team is available via email and chat.",

    faq_support_4_q: "Can I schedule a site visit?",
    faq_support_4_a:
      "Yes, schedule a site visit through the contact form or by calling us.",

    faq_support_5_q: "Is emergency support available?",
    faq_support_5_a:
      "Yes, emergency support is available for ongoing projects.",
  },

  sq: {
    welcome: "Ndërtojmë të ardhmen.",
    heroSubtitle: "Cilësi. Precizion. Besim.",
    services: "Shërbimet",
    ourActivity: "Aktiviteti Ynë",
    ourValues: "Vlerat Tona",
    partners: "Partnerët Tanë",

    // Services

    service1_title: "Punime Ekskavimi",
    service1_description:
      "Ofrojmë shërbime profesionale ekskavimi, nga pastrimi i vendit deri te gropat, duke siguruar që projekti juaj të fillojë në bazë të fortë.",
    service2_title: "Punime Druri",
    service2_description:
      "Druvarët tanë krijojnë punime druri të cilësisë së lartë, duke përfshirë kornizat, çatitë dhe mobiliet e personalizuara sipas nevojave tuaja.",
    service3_title: "Punime Hekuri",
    service3_description:
      "Specializojmë në punime hekuri të qëndrueshme dhe precize, përfshirë porta, gardhe dhe mbështetëse strukturore.",
    service4_title: "Punime Betoni",
    service4_description:
      "Ofrojmë një gamë shërbimesh betoni, nga themelet deri te finishet dekorative, për ndërtesa rezidenciale dhe komerciale.",
    service5_title: "Punime Çatie",
    service5_description:
      "Ekspertët tanë të çative sigurojnë çati të qëndrueshme dhe të besueshme, duke trajtuar instalime, riparime dhe zëvendësime.",
    service6_title: "Punime Muri Tulli",
    service6_description:
      "Ndërtojmë dhe riparojmë mure tullash me precizion, duke shtuar integritet strukturor dhe vlerë estetike për pronën tuaj.",
    service7_title: "Punime Suvatimi",
    service7_description:
      "Shërbimet tona të suvatimit ofrojnë finishe të lëmuara dhe të qëndrueshme për sipërfaqe të brendshme dhe të jashtme, duke përmirësuar hapësirën tuaj.",
    service8_title: "Punime Fasade",
    service8_description:
      "Transformoni pamjen e ndërtesës tuaj me shërbimet tona të ekspertizës për fasadat, përfshirë restaurimin, instalimin dhe mbulimin.",
    service9_title: "Sisteme Tenda",
    service9_description:
      "Projektimi dhe instalimi i sistemeve të tendave funksionale, duke siguruar strehim dhe pamje estetike për pronën tuaj.",
    service10_title: "Fasada të Ventiluara",
    service10_description:
      "Fasadat tona të ventiluara përmirësojnë efikasitetin e energjisë dhe qarkullimin e ajrit, duke i dhënë një pamje moderne ndërtesës suaj.",
    service11_title: "Punime Mozaik",
    service11_description:
      "Shërbimet tona të mozaikut përfshijnë gjithçka nga dyshemeja deri te muret, duke ofruar stile të ndryshme dhe instalime të cilësisë së lartë.",
    service12_title: "Punime Dekorative",
    service12_description:
      "Specializoheni në mbulesa dekorative që përmirësojnë pamjen dhe ndjesinë e hapësirës suaj, duke kombinuar bukurinë me mbrojtjen.",
    service13_title: "Punime Rinovimi",
    service13_description:
      "Shërbimet tona të rinovimit transformojnë hapësira ekzistuese, duke përmirësuar interierin dhe eksterierin sipas standardeve moderne.",
    service14_title: "Punime Hidraulike",
    service14_description:
      "Nga instalimet deri te riparimet, shërbimet tona hidraulike mbulojnë gjithçka nga tubat te pajisjet, duke siguruar një sistem të funksionueshëm.",
    service15_title: "Punime Izolimi",
    service15_description:
      "Ofrojmë zgjidhje izolimi për të përmirësuar efikasitetin e energjisë, reduktuar zhurmën dhe krijuar ambiente të rehatshme.",
    service16_title: "Punime Elektrike",
    service16_description:
      "Elektricistët tanë të licencuar ofrojnë instalime, riparime dhe mirëmbajtje të besueshme elektrike për ndërtesa rezidenciale dhe komerciale.",

    // Values

    value1_title: "Ekselencë dhe Cilësi",
    value1_description:
      "Bëjmë përpjekjet më të mira me pasion të pafund dhe shpirt sfidues për të përmbushur dhe tejkaluar çdo pritshmëri, për të qenë më të mirët në çdo mënyrë.",
    value2_title: "Integritet & Siguria",
    value2_description:
      "Përmbushim premtimin e misionit tonë përmes sjelljes që reflekton ndershmëri, përgjegjësi dhe drejtësi në veprim.",
    value3_title: "Puna në Grup & Bashkëpunimi",
    value3_description:
      "Punojmë së bashku drejt një qëllimi të përbashkët, duke përmirësuar gjithçka që bëjmë dhe duke u përmirësuar çdo ditë.",

    //Home

    home: "Faqja",
    mainHome: "Faqja Kryesore",
    features: "Vecori",
    dashboard: "Paneli",
    projects: "Projekt",
    allProjects: "Projektet",
    ProBuild: "Preventiv",
    materials: "Materialet",
    about: "Rreth Nesh",
    jobs: "Punët",
    reviews: "Vleresime",
    contact: "Kontakt",
    signIn: "Logohu",

    //Footer

    contacts: "Kontakti",
    address: "Rruga Kajo Karafili, Ndërtesa BimBashi, Kat 4, Tiranë, Shqipëri",
    phone: "+355 69 20 73 347",
    email: "Email",
    location: "Vendndodhja",
    locationText: "Kat 4, Tiranë, Shqipëri",
    rightsReserved: 'Të gjitha të drejtat e rezervuara nga "H&O"',

    //Contact

    contactUs: "Na Kontaktoni",
    contactDirect: "Kontaktoni drejtpërdrejt në:",
    name: "Emri",
    message: "Mesazhi",
    sendMessage: "Dërgo Mesazhin",
    formSuccess: "Faleminderit! Do t'ju kontaktojmë së shpejti.",
    formError: "Ops! Ka pasur një problem gjatë dërgimit të formularit.",
    contactImageAlt: "Na Kontaktoni",

    //About

    companyName: "H&O Kompania",
    aboutTitle: "Rreth H&O",
    aboutIntro:
      "H&O është një kompani ndërtimi me një reputacion të gjerë dhe të shkëlqyer, e ndërtuar mbi vlerat e shkëlqimit dhe integritetit, e provuar gjatë viteve.",
    aboutProjects:
      "Gjatë viteve, H&O ka përfunduar shumë projekte në fushën e ndërtimit civil dhe industrial, si ndërtesa banimi, ndërtimi industrial dhe infrastruktural, qendra sociale dhe kulturore, në bashkëpunim me kompani të ndryshme prestigjioze në Shqipëri.",
    aboutStartTitle: "Si Filloi!",
    aboutStartDescription:
      "E themeluar në 2002 si një biznes individual i fokusuar në ndërtimin dhe rindërtimin e ndërtesave banimi dhe tregtinë e materialeve ndërtimore, H&O ka rritur shpejt në një kompani ambicioze që ofron punë cilësore duke qenë inovative, e besueshme dhe e përkushtuar ndaj shkëlqimit.",
    totalProjects: "Projektet Totale",
    completed: "Të Përfunduara",
    inProgress: "Në Progres",
    safetyHealth: "Siguria dhe Shëndeti",
    safetyHealthPara1:
      "Tek H&O, ne i japim përparësi sigurisë dhe shëndetit të punonjësve, klientëve dhe partnerëve tanë. Angazhimi ynë ndaj sigurisë është i palëkundur, duke siguruar që të gjitha projektet të përmbushin standardet më të larta të sigurisë dhe praktikat më të mira.",
    safetyHealthPara2:
      "Përmes protokolleve rigoroze dhe vigjilencës së vazhdueshme, ne synojmë të ruajmë një ambient pune që promovon mirëqenien dhe sigurinë. Çdo projekt i përmbahet udhëzimeve strikte të shëndetit për të mbrojtur të gjithë të përfshirët, duke e bërë H&O lider në praktikat e përgjegjshme dhe etike.",
    safetyExample1: "Shembull sigurie 1",
    safetyExample2: "Shembull sigurie 2",
    safetyExample3: "Shembull sigurie 3",
    safetyExample4: "Shembull sigurie 4",

    //Reviews

    User: "Përdorues",
    logout: "Dil",
    loginFailed: "Dështoi logimi",
    shareExperience: "Shpreh përvojën tuaj",
    feedbackDesc: "Na tregoni mendimin tuaj — komenti juaj ka rëndësi.",
    leaveComment: "Lini një koment...",
    submitRating: "Dërgo Vlerësimin",
    alreadyRated: "Ju keni vlerësuar tashmë. Faleminderit!",
    topReviews: "Vlerësimet Kryesore",
    basedOnReviews: "Bazuar në {{count}} vlerësime",
    whatCustomersSay: "Çfarë thonë klientët tanë",

    //Projects

    ourProjects: "PROJEKTET TONA",
    seeMore: "Shiko më shumë",
    tiranaCieloTitle: "TIRANA CIELO",
    tiranaCieloDesc: "Kompleks rezidencial në Mjull Bathore pranë TEG.",
    samiFrasheriTitle: "SAMI FRASHERI",
    samiFrasheriDesc: "Rinovim pranë qendrës së Tiranës.",
    lakeViewTitle: "LAKE VIEW",
    lakeViewDesc: "Ndërtesë me standard të lartë në Tiranë.",
    deltaResidenceTitle: "DELTA RESIDENCE",
    deltaResidenceDesc: "Ndërtesë me standard të lartë në Tiranë.",
    katedraljaTitle: "KATEDRALJA RINGJALLJA E KRISHTIT",
    katedraljaDesc: "Kishë e re ortodokse në qendër të Tiranës.",
    hotelLuaniTitle: "HOTEL LUANI ARTE",
    hotelLuaniDesc:
      "Hoteli 5-katësh u ndërtua në qytetin e Shkodrës me standard të lartë...",
    spaWellnessTitle: "“LUANI A” SPA & WELLNESS CENTER",
    spaWellnessDesc:
      "Ndërtesa ndodhet në qytetin e Shkodrës, me standard të lartë...",
    aeroportiTitle: "AEROPORTI NENE TEREZA",
    aeroportiDesc: 'Aeroporti ndërkombëtar "Nënë Tereza" është aeroporti i ...',

    //Jobs

    backToAllJobs: "← Kthehu tek të gjitha pozicionet",
    searchPlaceholder: "Kërko",
    OpenPositions: "Pozicionet e Lira në Ndërtim",
    applyNow: "Apliko Tani",
    yourApplications: "Aplikimet Tuaja",
    jobTitle: "Pozicioni",
    appliedOn: "Aplikuar më",
    status: "Statusi",
    pending: "Në pritje",
    closed: "Mbyllur",
    noApplicationsYet: "Nuk keni aplikuar ende për ndonjë punë",
    responsibilities: "Detyrat",
    requirements: "Kërkesat",
    deadline: "Afati",
    jobDetailsNotFound: "Detajet e punës nuk u gjetën",
    fillAllFields:
      "Ju lutem plotësoni të gjitha fushat dhe ngarkoni CV-në tuaj.",
    Submit: "Dergo",
    formSubmitted: "Aplikimi u dërgua",

    // Construction Engineer

    constructionEngineerTitle: "Inxhinier Ndërtimi",
    constructionEngineerDescription:
      "Si Inxhinier Ndërtimi, do të mbikëqyrni dizajnin dhe zbatimin e projekteve, duke siguruar përputhshmëri me standardet e sigurisë dhe cilësisë.",
    responsibilityConstructionEngineer1:
      "Planifikoni, dizajnoni dhe mbikëqyrni projektet e ndërtimit nga fillimi deri në fund.",
    responsibilityConstructionEngineer2:
      "Përgatitni vlerësimet e kostove, buxhetet dhe afatet kohore.",
    responsibilityConstructionEngineer3:
      "Bashkëpunoni me arkitektët, kontraktorët dhe palët e interesuara.",
    responsibilityConstructionEngineer4:
      "Siguroni përputhshmëri me kodet e ndërtimit dhe rregulloret e sigurisë.",
    requirementConstructionEngineer1:
      "Diplomë bachelor në Inxhinieri Civile ose Ndërtimi.",
    requirementConstructionEngineer2:
      "Minimum 3 vjet përvojë në menaxhimin e projekteve të ndërtimit.",
    requirementConstructionEngineer3:
      "Aftësi të shkëlqyera në zgjidhjen e problemeve dhe komunikim.",
    requirementConstructionEngineer4:
      "Njohuri në AutoCAD, Revit ose softuer të ngjashëm dizajni.",

    // Construction Worker

    constructionWorkerTitle: "Punëtor Ndërtimi",
    constructionWorkerDescription:
      "Kërkojmë Punëtorë Ndërtimi të motivuar për t'u bashkuar me ekipin tonë në zbatimin e projekteve të ndërtimit me cilësi të lartë.",
    responsibilityConstructionWorker1:
      "Ndihmoni në përzierjen e betonit, përgatitjen e vendit dhe trajtimin e materialeve.",
    responsibilityConstructionWorker2:
      "Ndjekni me saktësi planet dhe udhëzimet e projektit.",
    responsibilityConstructionWorker3:
      "Përdorni me siguri veglat manuale dhe elektrike.",
    responsibilityConstructionWorker4:
      "Siguroni përputhshmëri me udhëzimet e sigurisë dhe shëndetit në vend.",
    requirementConstructionWorker1:
      "Përvojë e mëparshme në ndërtim ose punë të ngjashme e preferuar.",
    requirementConstructionWorker2:
      "Aftësi për të kryer punë fizike dhe për të punuar jashtë.",
    requirementConstructionWorker3: "Puna në grup dhe besueshmëri e fortë.",
    requirementConstructionWorker4:
      "Kuptim bazik i procedurave dhe mjeteve të ndërtimit.",

    // Construction Foreman

    constructionForemanTitle: "Kryeinspektor Ndërtimi",
    constructionForemanDescription:
      "Kryeinspektori i Ndërtimit do të udhëheqë dhe koordinojë ekipet e punëtorëve, duke siguruar që të gjitha operacionet të përfundojnë në mënyrë të sigurt, efikase dhe sipas afatit.",
    responsibilityConstructionForeman1:
      "Mbikëqyr punëtorët e ndërtimit dhe nënkontraktorët në vend.",
    responsibilityConstructionForeman2:
      "Monitoron progresin e projektit dhe raporton tek menaxheri i projektit.",
    responsibilityConstructionForeman3:
      "Siguron që standardet e sigurisë dhe cilësisë të zbatohen.",
    responsibilityConstructionForeman4:
      "Koordinon aktivitetet ditore dhe zgjidh çështjet në vend shpejt.",
    requirementConstructionForeman1:
      "Përvojë e provuar si Kryeinspektor ose rol mbikëqyrës i ngjashëm.",
    requirementConstructionForeman2:
      "Aftësi të forta udhëheqëse dhe komunikimi.",
    requirementConstructionForeman3:
      "Njohuri të shkëlqyera të proceseve të ndërtimit dhe praktikave të sigurisë.",
    requirementConstructionForeman4:
      "Aftësi për të lexuar planet dhe vizatimet teknike.",

    // Construction Archaeologist

    constructionArchaeologistTitle: "Arkeolog Ndërtimi",
    constructionArchaeologistDescription:
      "Si Arkeolog Ndërtimi, do të vlerësoni dhe monitoroni projektet e ndërtimit për të identifikuar dhe ruajtur gjetjet arkeologjike.",
    responsibilityConstructionArchaeologist1:
      "Kryeni vlerësime arkeologjike para dhe gjatë ndërtimit.",
    responsibilityConstructionArchaeologist2:
      "Dokumentoni gjetjet dhe përgatitni raporte të detajuara.",
    responsibilityConstructionArchaeologist3:
      "Bashkëpunoni me menaxherët e vendit për të minimizuar ndikimin në vend.",
    responsibilityConstructionArchaeologist4:
      "Siguroni përputhshmëri ligjore me standardet e ruajtjes së trashëgimisë.",
    requirementConstructionArchaeologist1:
      "Diplomë në Arkeologji, Antropologji ose fushë të ngjashme.",
    requirementConstructionArchaeologist2:
      "Aftësi të forta kërkimore dhe dokumentuese.",
    requirementConstructionArchaeologist3:
      "Aftësi për të punuar bashkëpunueshëm në vendet aktive të ndërtimit.",
    requirementConstructionArchaeologist4:
      "Vëmendje ndaj detajeve dhe respekt për trashëgiminë kulturore.",

    // Architectural Designer

    architecturalDesignerTitle: "Dizajner Arkitekture",
    architecturalDesignerDescription:
      "Kërkojmë një Dizajner Arkitekture kreativ për të prodhuar dizajne inovative për projekte rezidenciale dhe komerciale. ",
    responsibilityArchitecturalDesigner1:
      "Zhvilloni konceptet e dizajnit dhe vizualizime 3D.",
    responsibilityArchitecturalDesigner2:
      "Bashkëpunoni me ekipet e inxhinierisë dhe menaxherët e projektit.",
    responsibilityArchitecturalDesigner3:
      "Përgatitni vizatime teknike dhe specifikime.",
    responsibilityArchitecturalDesigner4:
      "Siguroni që dizajnet të përputhen me rregulloret lokale dhe qëllimet e qëndrueshmërisë.",
    requirementArchitecturalDesigner1:
      "Diplomë bachelor në Arkitekturë ose fushë të ngjashme.",
    requirementArchitecturalDesigner2:
      "Njohuri në AutoCAD, SketchUp ose Revit.",
    requirementArchitecturalDesigner3:
      "Portofol i fortë dizajni që tregon kreativitet dhe aftësi teknike.",
    requirementArchitecturalDesigner4:
      "Aftësi të shkëlqyera komunikimi dhe punë në grup.",

    // Project Coordinator

    projectCoordinatorTitle: "Koordinator Projekti",
    projectCoordinatorDescription:
      "Si Koordinator Projekti, do të ndihmoni në planifikimin, zbatimin dhe finalizimin e projekteve brenda buxhetit dhe afateve.",
    responsibilityProjectCoordinator1:
      "Ndihmoni në planifikimin, buxhetimin dhe raportimin.",
    responsibilityProjectCoordinator2:
      "Komunikoni progresin e projektit me palët e interesuara.",
    responsibilityProjectCoordinator3:
      "Mbani dokumentacionin e projektit dhe kontratat.",
    responsibilityProjectCoordinator4:
      "Mbështesni menaxherin e projektit në aktivitetet ditore.",
    requirementProjectCoordinator1:
      "Diplomë bachelor në Menaxhim, Inxhinieri ose fushë të ngjashme.",
    requirementProjectCoordinator2:
      "Aftësi të forta organizative dhe multitasking.",
    requirementProjectCoordinator3:
      "Aftësi të shkëlqyera në komunikim verbal dhe shkrim.",
    requirementProjectCoordinator4:
      "Njohuri të softuerëve të menaxhimit të projekteve është plus.",

    // Structural Engineer

    structuralEngineerTitle: "Inxhinier Struktural",
    structuralEngineerDescription:
      "Inxhinieri Struktural do të dizajnojë, planifikojë dhe mbikëqyrë ndërtimin e strukturave mbajtëse. ",
    responsibilityStructuralEngineer1:
      "Zhvilloni dizajne dhe llogaritje strukturore.",
    responsibilityStructuralEngineer2:
      "Rishikoni vizatimet arkitekturore për integritet struktural.",
    responsibilityStructuralEngineer3:
      "Bashkëpunoni me ekipet e ndërtimit dhe dizajnit.",
    responsibilityStructuralEngineer4:
      "Kryeni inspektime në vend dhe lëshoni raporte për përputhshmëri.",
    requirementStructuralEngineer1:
      "Diplomë në Inxhinieri Struktural ose Civile.",
    requirementStructuralEngineer2:
      "Njohuri të forta të Eurocodes dhe standardeve të dizajnit.",
    requirementStructuralEngineer3:
      "Përvojë me softuerët e analizës strukturore.",
    requirementStructuralEngineer4:
      "Vëmendje ndaj detajeve dhe aftësi për zgjidhjen e problemeve.",

    // Installation Foreman

    installationForemanTitle: "Kryeinspektor Instalimi",
    installationForemanDescription:
      "Kërkojmë një Kryeinspektor Instalimi me përvojë për të mbikëqyrur instalimin e sistemeve mekanike, elektrike dhe hidraulike.",
    responsibilityInstallationForeman1:
      "Planifikoni dhe mbikëqyrni aktivitetet e instalimit në vend.",
    responsibilityInstallationForeman2:
      "Mbikëqyrni teknikët dhe nënkontraktorët.",
    responsibilityInstallationForeman3:
      "Siguroni cilësi dhe përputhshmëri me standardet teknike.",
    responsibilityInstallationForeman4:
      "Monitoroni progresin dhe raportoni devijimet tek menaxhimi.",
    requirementInstallationForeman1:
      "Diplomë teknike në Inxhinieri ose fushë të ngjashme.",
    requirementInstallationForeman2:
      "Minimum 3 vjet përvojë si Kryeinspektor Instalimi.",
    requirementInstallationForeman3:
      "Aftësi të forta udhëheqëse dhe organizative.",
    requirementInstallationForeman4:
      "Njohuri të sistemeve MEP dhe vizatimeve teknike.",

    //Kalkulatori

    objectType: "Lloji i objektit",
    area: "Sipërfaqja (m²)",
    enterArea: "Shkruani sipërfaqen totale",
    quality: "Cilësia",
    pricePerM2: "Çmimi / m² (€)",
    workerPerM2: "Punëtori / m² (€)",
    transportPerM2: "Transporti / m² (€)",
    discount: "Zbritja (%)",
    tax: "Taksa (%)",
    totalCost: "Kosto totale e llogaritur",
    buyProject: "Blej Projektin",
    introTitle: " Planifikoni më zgjuar, ndërtoni më mirë.",
    introText:
      "Llogaritni shpejt kostot e ndërtimit – transparente, të thjeshta dhe të besueshme.",
    howItWorks: "Si Funksionon",
    step1: "Hapi 1: Zgjidhni llojin e objektit.",
    step2: "Hapi 2: Futni sipërfaqen.",
    step3:
      "Hapi 3: Zgjidhni cilësinë dhe kontrolloni kostot e llogaritura automatikisht.",
    step4: "Hapi 4: Llogaritni koston totale.",
    factTitle: "Vlerësim Profesional?",
    factText:
      "Gjeneroni vlerësime të sakta dhe transparente të kostos së ndërtimit për planifikim dhe vendimmarrje më të mirë.",
    errorMessage: "Ju duhet te logoheni!",

    //Features

    planningDesignTitle: "Planifikim & Projektim",
    planningDesignDesc:
      "Ofrojmë planifikim të detajuar dhe projektim profesional për të siguruar që çdo projekt të realizohet sipas standardeve më të larta.",

    engineeringTeamTitle: "Ekip Inxhinierësh",
    engineeringTeamDesc:
      "Ekipi ynë i inxhinierëve dhe specialistëve punon me përkushtim për të garantuar zgjidhje të sigurta, moderne dhe efikase.",

    constructionSiteTitle: "Zbatim në Terren",
    constructionSiteDesc:
      "Menaxhojmë dhe realizojmë çdo fazë të ndërtimit me profesionalizëm, duke respektuar afatet dhe cilësinë e punimeve.",

    premiumMaterialsTitle: "Materiale Premium",
    premiumMaterialsDesc:
      "Përdorim materiale ndërtimi të certifikuara dhe me cilësi të lartë për të garantuar qëndrueshmëri dhe rezultate afatgjata.",

    completedProjectsTitle: "Projekte të Përfunduara",
    completedProjectsDesc:
      "Portofoli ynë përfshin projekte të realizuara me sukses që dëshmojnë përvojën, cilësinë dhe besueshmërinë tonë.",
    featuresHeaderTitle: "Karakteristikat Tona",
    featuresHeaderDesc:
      "Zbuloni pikat kryesore që e bëjnë kompaninë tonë të besueshme, profesionale dhe të përkushtuar ndaj cilësisë.",

    //Cookie

    cookieTitle: "Ne përdorim cookies",
    cookieBannerMessage:
      "Ne përdorim cookies për të përmirësuar eksperiencën tuaj. Ju lutem zgjidhni preferencat tuaja:",
    essentialCookies: "Cookies esenciale",
    analyticsCookies: "Cookies analitike",
    marketingCookies: "Cookies marketingu",
    savePreferences: "Ruaj",
    acceptAll: "Prano të gjitha",

    //Aplication

    applyingFor: "Duke aplikuar për",
    resume: "CV",
    submitApplication: "Dërgo aplikimin",
    formSubmitted: "Aplikimi u dërgua!",
    applicationSuccess: "Aplikimi u dërgua me sukses!",
    somethingWrong: "Diçka shkoi keq.",
    serverError: "Ndodhi një gabim. Ju lutem provoni më vonë.",
    invalidEmail: "Ju lutem shkruani një email të vlefshëm.",
    seeApplications: "Shiko aplikimet",

    //Materials

    exploreMaterials: "Zbuloni Materialet",
    materialsIntro: "Këtu mund të gjeni informacion për materialet tona...",
    Wood: "Druri",
    "Premium quality wood for construction and design, offering durability and aesthetic appeal.":
      "Druri me cilësi të lartë për ndërtim dhe dizajn, ofron qëndrueshmëri dhe estetikë.",

    Concrete: "Betoni",
    "High-grade concrete for strong foundations and sustainable structures.":
      "Beton i klasit të lartë për themele të forta dhe struktura të qëndrueshme.",

    Steel: "Çeliku",
    "Robust and corrosion-resistant steel for architectural and industrial applications.":
      "Çelik i fortë dhe i qëndrueshëm për aplikime arkitekturore dhe industriale.",

    Glass: "Qelqi",
    "Crystal-clear glass for modern and sleek designs, ensuring durability and style.":
      "Qelq i pastër për dizajne moderne dhe elegante, i qëndrueshëm dhe stilist.",

    Tiles: "Tegela",
    "Elegant tiles with diverse patterns, perfect for interior and exterior spaces.":
      "Tegela elegante me modele të ndryshme, perfekte për hapësira të brendshme dhe të jashtme.",

    Granite: "Graniti",
    "Durable and elegant granite for countertops, flooring, and other construction needs.":
      "Graniti i qëndrueshëm dhe elegant për banakë, dysheme dhe nevoja të tjera ndërtimi.",

    Brick: "Tullat",
    "Reliable and affordable bricks for traditional and modern building projects.":
      "Tulla të besueshme dhe të përballueshme për projekte ndërtimi tradicionale dhe moderne.",

    Marble: "Mermeri",
    "Luxurious marble for sophisticated interiors and exteriors.":
      "Mermer luksoz për brendësi dhe jashtësi të sofistikuara.",

    Aluminum: "Alumini",
    "Lightweight and versatile aluminum for construction and design.":
      "Alumini i lehtë dhe fleksibël për ndërtim dhe dizajn.",

    PVC: "PVC",
    "Cost-effective and durable PVC for pipes, windows, and more.":
      "PVC me kosto të ulët dhe i qëndrueshëm për tuba, dritare dhe më shumë.",

    Sand: "Rërë",
    "Clean and fine sand ideal for masonry and plastering.":
      "Rërë e pastër dhe e imët ideale për muraturë dhe gipsim.",

    Cement: "Cementi",
    "High-quality cement for strong and durable structures.":
      "Cement i cilësisë së lartë për struktura të forta dhe të qëndrueshme.",

    Plasterboard: "Tavane gipsi",
    "Efficient and easy-to-install plasterboard for walls and ceilings.":
      "Plafon gipsi i lehtë për t’u instaluar për mure dhe tavan.",

    Asphalt: "Asfalti",
    "Reliable asphalt for durable and smooth roads and pavements.":
      "Asfalt i besueshëm për rrugë dhe trotuare të qëndrueshme dhe të lëmuara.",

    "Insulation Materials": "Materiale Izoluese",
    "Thermal and acoustic insulation for energy-efficient buildings.":
      "Izolim termik dhe akustik për ndërtesa energjetikisht efikase.",

    "Roofing Materials": "Materiale Mbulesash",
    "Durable and weather-resistant roofing materials for all building types.":
      "Materiale mbulesash të qëndrueshme dhe rezistente ndaj motit për të gjitha llojet e ndërtesave.",

    "Adhesives & Sealants": "Ngjitës dhe Sigurues",
    "High-quality adhesives and sealants for secure bonding and sealing.":
      "Ngjitës dhe siguresa me cilësi të lartë për lidhje dhe vulosje të sigurt.",

    Ceramics: "Qeramika",
    "Aesthetic and durable ceramics for interior and exterior applications.":
      "Qeramika estetike dhe e qëndrueshme për aplikime të brendshme dhe të jashtme.",

    Gypsum: "Gipsi",
    "Versatile gypsum for walls, ceilings, and decorative applications.":
      "Gips i shumëfishtë për mure, tavane dhe aplikime dekorative.",

    "Paints & Coatings": "Ngjyra dhe Llak",
    "Wide range of paints and coatings for protective and decorative finishes.":
      "Gama e gjerë e ngjyrave dhe llaqeve për përfundime mbrojtëse dhe dekorative.",

    "Pipes & Plumbing Materials": "Tuba dhe Pajisje Hidraulike",
    "Durable pipes and fittings for water supply and drainage systems.":
      "Tuba dhe pajisje hidraulike të qëndrueshme për furnizim me ujë dhe sistem kanalizimi.",

    "Electrical Materials": "Materiale Elektrike",
    "Cables, switches, and other electrical materials for residential and industrial use.":
      "Kabuj, çelësa dhe materiale të tjera elektrike për përdorim rezidencial dhe industrial.",

    Timber: "Druri i Përpunuar",
    "Natural and engineered timber for construction and furniture.":
      "Druri natyror dhe i përpunuar për ndërtim dhe mobilje.",

    Stone: "Guri",
    "Natural stone for landscaping, paving, and structural use.":
      "Gur natyror për landscaping, trotuar dhe përdorim strukturor.",

    "Metal Sheets": "Fletë Metalike",
    "High-quality metal sheets for roofing and industrial applications.":
      "Fletë metalike me cilësi të lartë për mbulesa dhe aplikime industriale.",

    "Composite Materials": "Materiale Kompozite",
    "Innovative composite materials for strength and lightweight construction.":
      "Materiale kompozite inovative për forcë dhe ndërtim të lehtë.",

    "Fiber Cement Boards": "Pllaka Fiber-Cement",
    "Durable and fire-resistant fiber cement boards for walls and cladding.":
      "Pllaka fiber-cement të qëndrueshme dhe rezistente ndaj zjarrit për mure dhe fasada.",

    //Njoftime
    Notifications: "Njoftimet",
    noNotifications: "Nuk ka njoftime",

    //Help

    welcomeMessage:
      "Mirësevini! Për qasje në llogari përdorni hyrjen kryesore.",
    categories: "Kategoritë",
    helpCenter: "Qendra e Ndihmës",
    noResults: "Na vjen keq, nuk u gjetën pyetje të përputhshme.",
    needAssistance: "Keni nevojë për më shumë ndihmë?",
    contactMessage:
      "Kontaktoni ekipin tonë të mbështetjes dhe do t'ju përgjigjemi sa më shpejt të jetë e mundur.",
    "Projects & Services": "Projektet & Shërbimet",
    "Payments & Billing": "Pagesat & Faturimi",
    "Account Settings": "Cilësimet e Llogarisë",
    "Technical Issues": "Çështje Teknike",

    // Projects & Services

    faq_project_1_q: "Si mund të filloj një projekt ndërtimi?",
    faq_project_1_a:
      'Plotësoni formularin e projektit nën "Shërbimet", dhe ekipi ynë do t\'ju kontaktojë.',

    faq_project_2_q: "Si mund të ndjek progresin e projektit tim?",
    faq_project_2_a:
      "Pasi të regjistroheni, mund të ndiqni progresin e projektit në profilin tuaj.",

    faq_project_3_q: "A mund të kërkoj disa projekte njëherësh?",
    faq_project_3_a:
      "Po, mund të dorëzoni disa kërkesa projektesh, dhe ekipi ynë do t'i menaxhojë me efikasitet.",

    faq_project_4_q: "A ofroni konsultim para fillimit?",
    faq_project_4_a:
      "Patjetër, ne ofrojmë konsultim falas për të diskutuar kërkesat tuaja.",

    faq_project_5_q: "Sa zgjat një projekt tipik?",
    faq_project_5_a:
      "Koha e projekteve varet nga shkalla e tyre, por ne japim kohëzgjatje të llogaritura për çdo projekt.",

    faq_project_6_q: "A mund të personalizoj dizajnin?",
    faq_project_6_a:
      "Po, ekipi ynë do të punojë me ju për të personalizuar dizajnin e projektit.",

    //Payments & Contracts

    faq_payment_1_q: "Çfarë mënyrash pagese pranoni?",
    faq_payment_1_a:
      "Pranojmë transfer bankar, kartë krediti dhe pagesa me para.",

    faq_payment_2_q: "A ofrohen kontrata zyrtare?",
    faq_payment_2_a:
      "Po, çdo projekt vjen me kontratë zyrtare për transparencë dhe siguri.",

    faq_payment_3_q: "A mund të marr rimbursim nëse është e nevojshme?",
    faq_payment_3_a:
      "Rimbursimet përpunohen sipas kushteve të kontratës që janë dakorduar para fillimit të projektit.",

    faq_payment_4_q: "A ofroni pagesa me këste?",
    faq_payment_4_a:
      "Po, pagesa me këste është e disponueshme për projektet e kualifikuara.",

    faq_payment_5_q: "A ofrohen fatura?",
    faq_payment_5_a:
      "Po, faturat e hollësishme lëshohen për çdo pagesë të kryer.",

    // Contact & Support

    faq_support_1_q: "Si mund të kontaktoj kompaninë?",
    faq_support_1_a:
      "Mund të na kontaktoni përmes formularit të kontaktit ose telefonit.",

    faq_support_2_q: "Cilat janë oraret tuaja të punës?",
    faq_support_2_a: "E hënë deri të premte, 08:00 - 17:00.",

    faq_support_3_q: "A ofroni mbështetje online?",
    faq_support_3_a:
      "Po, ekipi ynë i mbështetjes është në dispozicion përmes email dhe chat.",

    faq_support_4_q: "A mund të planifikoj një vizitë në vendin e ndërtimit?",
    faq_support_4_a:
      "Po, planifikoni një vizitë në vend përmes formularit të kontaktit ose duke na telefonuar.",

    faq_support_5_q: "A ofrohet mbështetje emergjente?",
    faq_support_5_a:
      "Po, mbështetje emergjente është në dispozicion për projektet aktuale.",
  },
};
